import DetallePost from './DetallePost';

export default function PostDetail() {
  return <DetallePost />;
}






